import { MultiSelectFilter } from './MultiSelectFilter'

export default MultiSelectFilter
